import api from './api'

const API = '/api/settings'

export const Setting = {
 
  get: function(params) {
    return api.get(API, {params: params})
  },
  show: function(id, params) {
    return api.get(API + '/' + id, params)
  },
  create: function(form) {
    return api.create(API, form)
  },
  update: function(id,form) {
    return api.update(API+'/'+id, form)
  },
  delete: function(id) {
    return api.delete(API+'/'+id)
  },
}
